import { saveOrder as saveOrderApi } from '../../api/order';
import { getAttendeeDeliveryMethodsPayloadForPlacingOrder } from '../../selectors/order';
import { getOrderId } from '../../selectors/order/typedOrderSelectors';
import { getFormDataForTaxExemption } from './getFormDataForTaxExemption';

export const saveOrderWithTaxExemption = () => {
    return (_dispatch, getState) => {
        const state = getState();
        const orderId = getOrderId(state);
        const deliveryMethods =
            getAttendeeDeliveryMethodsPayloadForPlacingOrder(state);
        const formData = getFormDataForTaxExemption(state);

        return saveOrderApi({
            orderId,
            formData,
            deliveryMethods,
        });
    };
};
